const ClaimCardStyles = {
  claimCard: {
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    border: "1px solid #C9E1EC",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
    marginBottom: "10px",
  },
  containerOne: {
    display: "flex",
    alignItems: "flex-start",
    gap: "50px",
    width: "100%",
    "@media (max-width:600px)": { flexDirection: "column" },
  },
  claimCardItemHeading: {
    color: "#1D252B",
    fontSize: "14px",
    fontWeight: 400,
    mb: 0.5,
    overflow: "hidden",
    fontFamily: "Noto Sans",
    textOverflow: "ellipsis",
    "@media (max-width:599px)": {
      fontSize: "16px",
    },
    "@media (min-width:600px) and (max-width:1024px)": {
      whiteSpace: "nowrap",
    },
  },
  claimCartItemContent: {
    color: "#1D252B",
    fontSize: "12px",
    fontWeight: 300,
    opacity: 0.8,
    marginTop: "0.5rem",
    "@media(max-width:599px)": {
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontFamily: '"Noto Sans"',
    },
    "@media (min-width: 1025px) and (max-width: 1366px)": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
};

export default ClaimCardStyles;
